import {LightTooltip} from "../../components/LightTooltip";
import Button from "@material-ui/core/Button";
import AddBoxIcon from "@material-ui/icons/AddBox";
import useStyles from "../muistyles";
import EditIcon from "@material-ui/icons/Edit";

// import SaveIcon from "@material-ui/icons/Download";
import SaveIcon from '@mui/icons-material/Download';

import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import FileCopyIcon from '@mui/icons-material/FileCopy';
import FormControl from  "@material-ui/core/FormControl"
import InputLabel from "@material-ui/core/InputLabel"
import Select from "@material-ui/core/Select"
import { MenuItem } from "@material-ui/core";
import RefreshIcon from '@mui/icons-material/Refresh';
import PortIcon from '@mui/icons-material/RadioButtonChecked';


import { getEnvironments } from "../../apis/environment";


export const TextInput =({tname,tplaceholder,tvalue,tHandleOnChange})=>{
    return(
        <div style={{textAlign:'left'}}>
            <label for={tname} style={{fontSize:"12px"}}>{tname}</label> 
            <input
                type="text"
                className="ipc"
                placeholder={tplaceholder}
                name={tname}
                onChange={(e) => tHandleOnChange(e)}
                value={tvalue}
                required
                style={{marginTop:'6px',marginBottom:'10px'}}
                />  
        </div>
    )
  }

export const SubmitButton=({sname})=>{
    return(
      <button type="submit" className="ips ipc">
         {sname}
    </button>
    )
}

export const SimpleButton=({sname,enable,onClickHandler,sbStyle})=>{
    // console.log("Simple Button "+enable)
    let cn = "ips ipc";
    
    if(!enable){
        cn = cn + " disableBgColor";
    }

    // console.log(`cn : ${cn}`)

    return(
      <button className={cn} style={sbStyle} onClick={e=>onClickHandler(e)} >
         {sname}
      </button>
    )
}

export const CancelButtonModal=({onClickHandler})=>{

    return(
        <button className="ips ipc" onClick={onClickHandler}>
            Cancel
        </button>
    )

  }

export const SelectInput =({sname,svalueList,svalue,onChangeHandler})=>{
    console.log(`SelectInput ${JSON.stringify(sname)} ${JSON.stringify(svalueList)}}`)
    return(
      <div style={{textAlign:'left'}}>
          <label for={sname} style={{fontSize:"12px"}}>{sname}</label>
          <select name={sname} className="ipc" value={svalue} onChange={e => onChangeHandler(e)}>
              {svalueList.map(v=>(
                  <option value={v.value}>{v.label}</option> 
              ))}
          </select>
      </div>
    )
}

export const Header =({name})=>{
    return (
      <h1 style={{ fontSize: "x-large", color: "black" }}>{name}</h1>
    )
}



export function AddButton ({toolTip,text,onClickHandler}){
    const classes = useStyles();
    return(
        <LightTooltip title={toolTip}>
            <Button
                variant="contained"
                color="primary"
                onClick={onClickHandler}
                className={classes.button}
                startIcon={<AddBoxIcon fontSize="inherit" />}
            >
                {text}
            </Button>
        </LightTooltip>
    )
}

const newStyle = {
    background: 'white', color:'#8da5ed', borderRadius:'20px', boxShadow: "1px 1px 2px 2px lightgrey", padding:'3px', marginLeft:'1px'
}

export const SaveAgentConfigButton = ({toolTip,updateObj,onClickHandler}) => {

    return(
    <LightTooltip title={toolTip}>
            <IconButton onClick={(e) => onClickHandler(e, updateObj)}>
              <SaveIcon style={newStyle}></SaveIcon>
            </IconButton>
    </LightTooltip>
    )
}


export const UpdateButton = ({toolTip,updateObj,onClickHandler}) => {

    return(
    <LightTooltip title={toolTip}>
            <IconButton onClick={(e) => onClickHandler(e, updateObj)}>
              <EditIcon className='roundButton'></EditIcon>
            </IconButton>
    </LightTooltip>
    )
}

export const DeleteButton=({toolTip,delObj,onClickHandler}) => {
    return(
        <LightTooltip title={toolTip}>
            <IconButton  onClick={(e) => onClickHandler(e, delObj)}>
            <DeleteIcon className='roundButton' ></DeleteIcon>
            </IconButton>
      </LightTooltip>
    )
}

export const CloneButton=({toolTip,text,onClickHandler}) =>{
    const classes = useStyles();    
    return (
        
        <LightTooltip title={toolTip}>
            <Button
                variant="contained"
                color="primary"
                onClick={onClickHandler}
                className={classes.button}
                startIcon={<FileCopyIcon fontSize="inherit" />}
            >
                {text}
            </Button>
        </LightTooltip>
    )
}

export const TButton=({toolTip,text,onClickHandler,startIcon,enabled}) =>{
    const classes = useStyles();    
    if(enabled === undefined) 
        enabled = true;
    return (
        
        <LightTooltip title={toolTip}>
            <Button
                variant="contained"
                color="primary"
                onClick={onClickHandler}
                className={classes.button}
                startIcon={startIcon}
                disabled={!enabled}
                
            >
                {text}
            </Button>
        </LightTooltip>
    )
}


export const SelectEnvironment =({selectedEnv, onChangeHandler})=>{
    // console.log(`SelectEnvironment ${selectedEnv}`)

    
    const renderMenuItems = ()=>{

        getEnvironments().then((environments)=>{
        // console.log(environments)
        if (environments.result != "success")
        {return} 
        
        return ( environments.data.map( env =>{
            <MenuItem value={env.environment}>{env.environment}</MenuItem> 
        }))
        });
        
    
    
    }
    

    return(
        <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
        <InputLabel id="Environment">Environment</InputLabel>
        <Select
          labelId="env-label"
          id="env-id"
          value={selectedEnv}
          onChange={e=>onChangeHandler(e)}
          label="Environment"
        >
          
          <MenuItem value="DEV">DEV</MenuItem>
          <MenuItem value="QA">QA</MenuItem>
          <MenuItem value="UAT">UAT</MenuItem>
          <MenuItem value="PROD">PROD</MenuItem>
        {/* {renderMenuItems()} */}
        </Select>
      </FormControl>

    )
}


export const SelectDuration =({selectedDuration, onChangeHandler})=>{
    return(
        <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
        <InputLabel style={{marginLeft:'40px', marginRight:'20px', minWidth: '120px'}} id="Duration">Time Range</InputLabel>
        <Select
          labelId="duration-label"
          id="duration-id"
          value={selectedDuration}
          onChange={e=>onChangeHandler(e)}
          label="Time Range"
          style={{marginLeft:'40px', marginRight:'20px'}}
        >
          
          <MenuItem value="WEEK">WEEK</MenuItem>
          <MenuItem value="MONTH">MONTH</MenuItem>
          <MenuItem value="YEAR">YEAR</MenuItem>
          <MenuItem value="DAY">DAY</MenuItem>
        </Select>
      </FormControl>

    )
}

export const PortButton =({onClickHandler})=>{
    const classes = useStyles();  
    return(
    <LightTooltip title='Manage Agent Port'>
        <IconButton
            
            color="primary"
            // className={classes.button}
            onClick={onClickHandler}
            size="large"
            // style={{float:'right'}}
            
        >
            <PortIcon fontSize="inherit"/>
        </IconButton>
    </LightTooltip>
    )
}


export const RefreshButton =({onClickHandler})=>{
    const classes = useStyles();  
    return(
    <LightTooltip title='Refresh'>
        <IconButton
            
            color="primary"
            // className={classes.button}
            onClick={onClickHandler}
            size="large"
            // style={{float:'right'}}
            
        >
            <RefreshIcon fontSize="inherit"/>
        </IconButton>
    </LightTooltip>
    )
}






